import { render, staticRenderFns } from "./OverlayAlert.vue?vue&type=template&id=6923a27d&scoped=true&"
import script from "./OverlayAlert.vue?vue&type=script&lang=js&"
export * from "./OverlayAlert.vue?vue&type=script&lang=js&"
import style0 from "./OverlayAlert.vue?vue&type=style&index=0&id=6923a27d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923a27d",
  null
  
)

export default component.exports